<template>
  <nav class="nav-bar" :class="{ scrolled: isScrolled }">
    <div class="nav-content section-container">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="MP3 Converter Logo" class="logo-img">
        <router-link to="/" class="logo-text">MP3 Converter - Audio Trimmer</router-link>
      </div>
      <div class="nav-links">
        <router-link to="/" class="nav-link">Home</router-link>
        <a href="#features" class="nav-link">Features</a>
        <a href="#download" class="nav-link">Download</a>
        <router-link to="/help" class="nav-link">Help</router-link>
      </div>
      <button class="mobile-menu-btn">
        <i class="fas fa-bars"></i>
      </button>
    </div>
  </nav>
</template>

<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1rem 0;
  background: rgba(10, 10, 10, 0.6);
  backdrop-filter: blur(10px);
  z-index: 100;
  transition: all 0.3s ease;
}

.nav-bar.scrolled {
  background: rgba(10, 10, 10, 0.9);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.logo-text:hover {
  opacity: 0.8;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 3rem;
}

.nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--primary-gradient);
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 1.5rem;
  cursor: pointer;
}

@media (max-width: 1024px) {
  .logo-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  
  .mobile-menu-btn {
    display: block;
  }

  .logo-text {
    font-size: 1rem;
  }
}
</style>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isScrolled = ref(false)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script> 